// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TNt4GwDHNj3YdldVnwF8 {
  padding: 16px 46px;
  background-color: rgba(66, 132, 91, 0.1019607843);
  border-radius: 4px;
  gap: 10px;
  border: none;
  margin-bottom: 1.25rem;
}
.TNt4GwDHNj3YdldVnwF8 .rWP64zjiryu1TNQ4r2FH {
  display: flex;
  align-items: center;
}
.TNt4GwDHNj3YdldVnwF8 .rWP64zjiryu1TNQ4r2FH .q1a2wde6m7HXtKYNogom {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #333333;
}
.TNt4GwDHNj3YdldVnwF8 .rWP64zjiryu1TNQ4r2FH .aFBZ7qBEM2JQ6MRjQFSd {
  height: 20px;
  width: 20px;
  margin-left: 4px;
}
.TNt4GwDHNj3YdldVnwF8 .C5Omb1H6osMEqBjT8M6Q {
  font-family: "Poppins";
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #666666;
  font-weight: 400;
}
.TNt4GwDHNj3YdldVnwF8 .C5Omb1H6osMEqBjT8M6Q span {
  font-family: "Roboto";
  font-weight: 500;
  color: #333333;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successReferralCard": `TNt4GwDHNj3YdldVnwF8`,
	"titleContainer": `rWP64zjiryu1TNQ4r2FH`,
	"titleText": `q1a2wde6m7HXtKYNogom`,
	"titleIcon": `aFBZ7qBEM2JQ6MRjQFSd`,
	"infoText": `C5Omb1H6osMEqBjT8M6Q`
};
export default ___CSS_LOADER_EXPORT___;
